// Import required dependencies
import ToDoListItem from "./ToDoListItem";
import { useState, useEffect } from "react";
import serverURL from "../../config/serverConfig";
import { X, ChevronLeft, Plus, CornerRightDown } from 'lucide-react';


// Component: ToDoList
const ToDoList = (props) => {

    // State variables
    const [toDoList, setToDoList] = useState([]); // Holds the list of to-do items
    const [editing, setEditing] = useState(false)
    const [editableList, setEditableList] = useState(); // Editable JSX list
    const [newItem, setNewItem] = useState({ id: "", detail: "", status: "not started" }); // New to-do item template
    const [createNewItem, setCreateNewItem] = useState(false); // Flag to show/hide new item form
    const [hideCompleted, setHideCompleted] = useState(true); // Flag to hide completed items

    // Function to update the to-do list on the server
    const updateToDoList = (newList) => {
        fetch(`${serverURL}updateToDoList`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                project_id: props.project_id,
                detail: newList,
            }),
        })
        .then(response => response.json())
        .then(data => {
            // console.log("To-Do list updated:", data);
        })
        .catch(error => {
            console.error("Error updating to-do list:", error);
        });
    };

    const deleteItem = (index) => {
        //console.log((toDoList));
        const tempList = [...toDoList];
        tempList.splice(index, 1);
        //console.log(tempList);
        setToDoList(tempList);
        updateToDoList(tempList);
    }

    // Effect to load the to-do list from the server when the component mounts
    useEffect(() => {
        fetch(`${serverURL}getToDoList`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ project_id: props.project_id }),
        })
        .then(response => response.json())
        .then(jsonData => {
            const loadedList = jsonData[0]?.detail || [];
            setToDoList(loadedList);
        })
        .catch(error => {
            console.error("Error loading to-do list:", error);
        });
    }, [props.project_id]);

    const formatStatus = (rawStatus) =>{
        if (rawStatus == "not started"){
            return "not_started"
        }
        if (rawStatus == "in progress"){
            return "in_progress"
        }
        if (rawStatus == "complete"){
            return "_complete"
        }
    }
    // Effect to generate the editable list whenever toDoList changes
    useEffect(() => {
        if (toDoList) {

            // Sort the to-do list by id in descending order and then by status
            toDoList.sort((a,b) => b.id - a.id)
            // let compare = (a, b) => {
            //     if (a.status != "complete") {
            //         return -1;
            //     }
            //     else {
            //         return 0
            //     }
            // };
            // toDoList.sort(compare)

            const toDoListItems = toDoList.map((item, index) => {
                if (hideCompleted && item.status === 'complete') {
                    return null;
                }
                return (
                <div key={index} id="toDoItem" className={formatStatus(toDoList[index].status)+ " "}>
                    <textarea
                        id = "toDoItemDetail"
                        className="detail text-xs"
                        rows={2}
                        value={item.detail} // <- controlled component
                        onChange={(e) => {
                            const tempList = [...toDoList];
                            tempList[index].detail = e.target.value;
                            setToDoList(tempList);
                            updateToDoList(tempList);
                        }}
                    />
                    <div className="toDoItemRight static w-100 text-black">
                        <span className=" flex justify-end text-black"><button className="tooltip" onClick={()=>(deleteItem(index))}><X size={16} strokeWidth={2}/><div className="tooltiptext">delete item</div></button></span>
                        <form id="statusSelect" className="status grid grid-cols-3 m-center  w-[60px] ">
                            <div className="radio notStarted flex m-auto">
                                <label>
                                    <input type="radio" value="option1" className="cursor-pointer"
                                        checked={item.status === 'not started'} 
                                        onChange={(e) => {
                                            const tempList = [...toDoList];
                                            tempList[index].status = 'not started';
                                            setToDoList(tempList);
                                            updateToDoList(tempList);
                                        }}
                                    />
                                </label>
                            </div>
                            <div className="radio inProgress flex m-auto">
                                <label>
                                    <input type="radio" value="option2" className="cursor-pointer"
                                        checked={item.status === 'in progress'}
                                        onChange={(e) => {
                                            const tempList = [...toDoList];
                                            tempList[index].status = 'in progress';
                                            setToDoList(tempList);
                                            updateToDoList(tempList);
                                        }}
                                    />
                                </label>
                            </div>
                            <div className="radio complete flex m-auto">
                                <label>
                                    <input type="radio" value="option3" className="cursor-pointer"
                                        checked={item.status === 'complete'}
                                        onChange={(e) => {
                                            const tempList = [...toDoList];
                                            tempList[index].status = 'complete';
                                            setToDoList(tempList);
                                            updateToDoList(tempList);
                                        }}
                                    />
                                </label>
                            </div>

                        </form>
                        <div className="statusText">
                            <div className={formatStatus(toDoList[index].status)}>
                                {item.status}
                            </div>
                        </div>
                    </div>
                </div>
                );
            });

            setEditableList(toDoListItems.filter(Boolean));
        }
    }, [toDoList, hideCompleted]);

    // Function to add a new item to the to-do list
    const addNewItem = (e) => {
        e.preventDefault();
        const tempList = [...toDoList];
        tempList.push({
            id: tempList.length,
            detail: newItem.detail,
            status: newItem.status
        });
        setToDoList(tempList);
        setNewItem({ id: "", detail: "", status: "not started" }); // clear/refresh new item form
        updateToDoList(tempList);
        setCreateNewItem(false)
    };

    const completedCount = toDoList.filter((item) => item.status === 'complete').length;

    // Render the component
    return (
        // <div id="toDoList" className="w-md max-w-md min-w-[480px]">
        <div id="toDoList" className="flex flex-col">
            <h5 className="blockHeader">To Do</h5>
            <button
                onClick={() => setHideCompleted(!hideCompleted)}
                className="self-end text-xs text-gray-400 hover:text-white"
            >
                {hideCompleted ? "Show completed" : "Hide completed"}
            </button>
            <div className="flex flex-col gap-2 mt-3 mb-4">
                {editableList}
            </div>

            {hideCompleted && completedCount > 0 && (
                <div className="flex items-center gap-2 text-xs text-gray-500 mb-4">
                    <div className="flex-1 h-px bg-gray-700" />
                    <span>Completed ({completedCount})</span>
                    <div className="flex-1 h-px bg-gray-700" />
                </div>
            )}

            <div id="newItemFormContainer" className="glassBackBlack absolute py-5 px-7 flex m-auto w-[75%] h-[250px]" style={{ display: createNewItem ? 'block' : 'none'}}>
                <div className="flex">
                    <h5 className="w-full">ADD A TO-DO ITEM</h5>
                    <button className="flex align-center text-xs" onClick={() => setCreateNewItem(false)}>
                        <ChevronLeft size={14}/>CANCEL
                    </button>
                </div>
                <form onSubmit={addNewItem} id="newItemForm" className="mt-4">
                    <textarea 
                        className="detail text-black rounded-md mb-2 text-xs h-[100px]"
                        onChange={(e) => setNewItem({ ...newItem, detail: e.target.value })}
                        value={newItem.detail}
                        placeholder="New item detail"
                    />
                    <button type="submit">ADD</button>
                </form>
            </div>
            {editableList && editableList.length > 0 ?
                <>
                </>
            :
                <div className="flex self-end text-xs text-gray-500 mt-4 absolute bottom-12 right-6" style={{ display: createNewItem ?  'none' :'flex'}}>
                    Click here to add to your to-do list. <div className="bounce"><CornerRightDown /></div>
                </div>
            }
            <button className="newItemButton absolute flex items-center justify-center w-[30px] h-[30px] rounded-full self-end bottom-3" style={{ display: createNewItem ?  'none' :'flex'}} onClick={() => setCreateNewItem(!createNewItem)} >
                <Plus size={20} strokeWidth={1.25}/>
            </button>
        </div>
    );
};

export default ToDoList;

